import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { ELocale } from "@rentiohq/shared-frontend/dist/types/i18n.types";
import { formatAddress } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import {
  EField,
  IExtraData,
} from "./schema.propertyApplicationNotEligible.types";

const getDefaultTenantFeedbackText = (extraData: IExtraData) => {
  const { applications, localeMessages, user, property } = extraData;

  const singleApplication =
    applications.length === 1 ? applications[0] : undefined;
  const userLocal = singleApplication?.contacts?.[0]?.language || ELocale.NL;
  const localeMessage = localeMessages[userLocal];

  if (!localeMessage) {
    return undefined;
  }

  const params: { [key: string]: string | null | undefined } = {
    address: formatAddress(extraData.property),
    applicant: singleApplication
      ? getName(singleApplication?.contacts[0])
      : "{{applicants}}",
    actor: applications[0]?.broker?.name || getName(user),

    propertyId: `${property.id}`,
    propertyInfoId: `${property.propertyInfoId}`,

    propertyReference: property.reference,
    propertyDescription: property.description,
    propertyName: property.name,

    refDewaele: property.refDewaele,
    refMaxImmo: property.refMaxImmo,
    refOmnicasa: property.refOmnicasa,
    refRealSuite: property.refRealSuite,
    refSkarabee: property.refSkarabee,
    refSweepbright: property.refSweepbright,
    refWhise: property.refWhise,
    refZabun: property.refZabun,
  };

  let result = localeMessage;
  Object.keys(params).forEach(key => {
    result = result.replaceAll(`{{${key}}}`, params[key] || "");
  });

  return result;
};

export const getInitialValues = (extraData: IExtraData) => {
  return {
    [EField.TenantFeedbackText]: getDefaultTenantFeedbackText(extraData),
  };
};
